import { saveAs } from 'file-saver';

export default function downloadFile(
  filenameWithoutType,
  filetype,
  base64Data
) {
  let dataBlob;
  // Convert the data to be blob-able
  const binary = atob(base64Data.replace(/\s/g, ''));
  const len = binary.length;
  const buffer = new ArrayBuffer(len);
  const view = new Uint8Array(buffer);
  for (let i = 0; i < len; i++) {
    view[i] = binary.charCodeAt(i);
  }

  if (filetype === 'PDF') {
    dataBlob = new Blob([view], { type: 'application/pdf' });
  } else if (filetype === 'docx' || filetype === 'DOCX') {
    dataBlob = new Blob([view], {
      type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    });
  } else if (filetype === 'xlsx' || filetype === 'XLSX') {
    dataBlob = new Blob([view], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
  }

  const extension =
    filetype === 'docx' || filetype === 'DOCX'
      ? 'docx'
      : filetype === 'xlsx' || filetype === 'XLSX'
        ? 'xlsx'
        : filetype;
  saveAs(dataBlob, filenameWithoutType + '.' + extension);
}
